import { render, staticRenderFns } from "./nothing_to_merge.vue?vue&type=template&id=f4bb1be6"
import script from "./nothing_to_merge.vue?vue&type=script&lang=js"
export * from "./nothing_to_merge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports